class EsiGeo {
	constructor() {
		let zip = this.getValueById('esi_geo_zip');
        this.zip = zip ? zip.substring(0, 5) : null;
        this.dma = this.getValueById('esi_geo_dma') || '';
		this.asnum = this.getValueById('esi_geo_asnum') || '';
		this.nielsonDMACodes = {
            524: 'ATLANTA',
            520: 'AUGUSTA',
            635: 'AUSTIN',
            800: 'BAKERSFIELD',
            716: 'BATON ROUGE',
            746: 'BILOXI',
            630: 'BIRMINGHAM',
            648: 'CHAMPAIGN-SPRNGFLD-DECATUR',
            519: 'CHARLESTON',
            517: 'CHARLOTTE',
            575: 'CHATTANOOGA',
            602: 'CHICAGO',
            510: 'CLEVELAND',
            546: 'COLUMBIA',
            522: 'COLUMBUS, GA',
            535: 'COLUMBUS, OH',
            600: 'CORPUS CHRISTI',
            623: 'DALLAS-FT WORTH',
            542: 'DAYTON',
            505: 'DETROIT',
            765: 'EL PASO',
            513: 'FLINT-SAGINAW-BAY CITY',
            866: 'FRESNO-VISALIA',
            670: 'FT SMITH',
            592: 'GAINESVILLE',
            563: 'GRAND RAPIDS-KALMZOO-B CRK',
            658: 'GREEN BAY-APPLETON',
            518: 'GREENSBORO, NC',
            567: 'GREENVILLE, SC',
            636: 'HARLINGEN-MCALLEN',
            618: 'HOUSTON',
            691: 'HUNTSVILLE',
            527: 'INDIANAPOLIS',
            718: 'JACKSON, MS',
            561: 'JACKSONVILLE',
            616: 'KANSAS CITY',
            557: 'KNOXVILLE, TN',
            642: 'LAFAYETTE',
            551: 'LANSING',
            693: 'LITTLE ROCK-PINE BLUFF',
            803: 'LOS ANGELES',
            529: 'LOUISVILLE',
            651: 'LUBBOCK',
            669: 'MADISON',
            640: 'MEMPHIS',
            528: 'MIAMI-FT. LAUDERDALE',
            617: 'MILWAUKEE',
            686: 'MOBILE',
            828: 'MONTEREY-SALINAS',
            698: 'MONTGOMERY-SELMA',
            659: 'NASHVILLE',
            622: 'NEW ORLEANS, LA',
            633: 'ODESSA-MIDLAND',
            650: 'OKLAHOMA CITY',
            534: 'ORLANDO-DAYTONA BCH-MELBRN',
            656: 'PANAMA CITY',
            560: 'RALEIGH-DURHAM (FAYETVLLE)',
            811: 'RENO',
            862: 'SACRAMNTO-STKTN-MODESTO',
            641: 'SAN ANTONIO',
            825: 'SAN DIEGO',
            807: 'SAN FRANCISCO-OAK-SAN JOSE',
            612: 'SHREVEPORT',
            588: 'SOUTH BEND-ELKHART',
            619: 'SPRINGFIELD MO',
            609: 'ST LOUIS',
            547: 'TOLEDO',
            605: 'TOPEKA',
            671: 'TULSA',
            548: 'WEST PALM BEACH',
            678: 'WICHITA-HUTCHINSON PLUS',
            550: 'WILMINGTON'
        };
	}

	getValueById(id) {
		let element = document.getElementById(id);

		if (!element || !element.innerHTML || element.innerHTML[0] === '$') return null;

		return element.innerHTML;
	}


}

export default new EsiGeo();



// WEBPACK FOOTER //
// ./assets/components/fsUtils/EsiGeo.js